import { Injectable } from '@angular/core'

declare global {
    interface Window {
        tap?: {
            (action: 'conversion', evID: string, val: number): void
            (action: 'customer', cusID: string): void
        }
    }
}

@Injectable({
    providedIn: 'root',
})
export class TapfiliateService {
    public trackPurchase(value: number) {
        // if (document.location.host !== 'app.wisepelican.com') {
        //     return
        // }

        if ('disabled' !== null) {
            return
        }

        if (value <= 0) {
            return
        }

        const id = '' + Date.now()
        try {
            if (window.tap) {
                window.tap('conversion', id, value)
            }
        } catch (err) {}
    }

    public trackCustomer(customerID: string) {
        // if (document.location.host !== 'app.wisepelican.com') {
        //     return
        // }

        if ('disabled' !== null) {
            return
        }

        if (customerID === '') {
            // Check if needed
            return
        }

        try {
            if (window.tap) {
                window.tap('customer', customerID)
            }
        } catch (err) {}
    }
}
